import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'sanitizeHtml'
})
export class SanitizeHtmlPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(untrustedHtml: string): SafeHtml {
    if (!untrustedHtml) { return ''; }

    // Angular's SecurityContext.HTML strips data: URLs from src attributes,
    // which breaks SVG/image content inserted via the Quill editor.
    // Strategy: stash data:image/* URLs behind safe placeholders, run the
    // full Angular sanitizer (handles scripts, event handlers, etc.), then
    // restore the image data URLs before returning trusted HTML.
    const stash = new Map<string, string>();
    let idx = 0;
    const PLACEHOLDER_PREFIX = '__SAFE_IMG_DATA_';

    const withPlaceholders = untrustedHtml.replace(
      /src="(data:image\/[^"]+)"/gi,
      (_match: string, dataUrl: string) => {
        const key = `${PLACEHOLDER_PREFIX}${idx++}__`;
        stash.set(key, dataUrl);
        return `src="${key}"`;
      }
    );

    let sanitized = this.sanitizer.sanitize(SecurityContext.HTML, withPlaceholders) || '';

    stash.forEach((dataUrl: string, key: string) => {
      sanitized = sanitized.replace(key, dataUrl);
    });

    return this.sanitizer.bypassSecurityTrustHtml(sanitized);
  }

}
